import client from '../../client';

const PATH = '/v2/classifier/items'

/**
 * Get the items with the given options and filters.
 *
 * For more information please read the backend docs.
 *
 * @param {Object} params to send in the query.
 * @returns {Object}
 */
function get(params) {
  return client.get(PATH, { params }).then(({ data }) => data);
}


/**
 * Use the same parameters for the get but instead of getting the items
 * it will get the total amount of them.
 * 
 * @param {Object} params to send in the query.
 * @returns {Number} with the total amount of items.
 */
get.count = (params) => {
  return client.get(`${PATH}/count`, { params }).then(({ data }) => data.count);
}


export default get
